function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M24.4443 44.4444L-0.000111695 44.4444L-0.000110626 20L24.4443 44.4444Z",
  fill: "#FF5670"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22 5.74365C21.4651 5.74365 20.9373 5.86675 20.4575 6.10341L5.44315 13.5139C4.63804 13.9088 3.95927 14.5209 3.48341 15.281C3.00718 16.0417 2.75315 16.9204 2.75001 17.8178L2.75 17.8226V33.6875C2.75 36.3619 4.94125 38.5 7.60719 38.5H36.3963C39.0622 38.5 41.2534 36.3619 41.2534 33.6875L41.2535 17.8226L41.2534 17.8171C41.2498 16.9192 40.9951 16.0401 40.518 15.2794C40.0414 14.5194 39.3619 13.9079 38.5562 13.5136L38.5536 13.5124L23.5425 6.10341C23.0627 5.86675 22.5349 5.74365 22 5.74365ZM37.7068 15.2456L37.7036 15.247L37.9501 14.7475L37.7068 15.2456ZM38.5034 33.6875V18.0484L28.5864 25.5591L34.9898 30.5397C35.5892 31.0059 35.6972 31.8698 35.2309 32.4692C34.7647 33.0687 33.9008 33.1766 33.3014 32.7104L22.1931 24.0702C22.0724 23.9764 21.9239 23.9254 21.771 23.9254C21.6181 23.9254 21.4696 23.9764 21.3489 24.0702L21.3489 24.0703L10.2397 32.7104C9.64032 33.1766 8.77644 33.0686 8.31023 32.4692C7.84401 31.8698 7.95201 31.0059 8.55145 30.5397L14.9683 25.549L5.5 18.3967V33.6875C5.5 34.8099 6.42656 35.75 7.60719 35.75H36.3963C37.5769 35.75 38.5034 34.8099 38.5034 33.6875ZM6.78296 15.9194L17.2162 23.8006L19.6605 21.8996L19.6606 21.8995C20.264 21.4302 21.0066 21.1754 21.771 21.1754C22.5355 21.1754 23.2781 21.4302 23.8815 21.8996L26.3393 23.8113L36.9402 15.7827L22.3258 8.56965C22.2246 8.51973 22.1129 8.49365 22 8.49365C21.8871 8.49365 21.7757 8.51961 21.6744 8.56953L6.78296 15.9194Z",
  fill: "#0E185B"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 44,
  height: 44,
  fill: "white"
})));

var SvgMailOpenOutline = function SvgMailOpenOutline(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMailOpenOutline, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mail-open-outline.fc02eedc.svg";
export { ForwardRef as ReactComponent };